import { useTranslation } from 'next-i18next'

export type TimeStamp = 'morning' | 'midday' | 'evening'

const useTimeStampMap = () => {
  const { t } = useTranslation()

  return new Map<TimeStamp, string>([
    ['morning', t('venue.requestForm.successStep.additionalForm.timestamp.morning')],
    ['midday', t('venue.requestForm.successStep.additionalForm.timestamp.midday')],
    ['evening', t('venue.requestForm.successStep.additionalForm.timestamp.evening')],
  ])
}

export default useTimeStampMap
